module.exports = __webpack_public_path__ + "img/image-female-phone.cf22e6c4.jpg";